<section class="page-wrapper">
    <article class="heading-portion">
        <h3 class="heading-text">{{data.headingText}}</h3>
    </article>
    <article class="body-portion">
        <span class="body-text" [innerHTML]="data.bodyText"></span>
        <div class="difference-amount">
            <span class="amount-label">
                Amount Difference: 
            </span>
            <span class="amount-txt">
                <app-indian-currency-formatter
                    [amount]="data.differenceAmount"
                ></app-indian-currency-formatter>
            </span>
        </div>
    </article>
    <article class="footer">
        <button class="btn-outline" (click)="onChangeAllocation()">{{data.buttonName[0]}}</button>
        <button class="btn-normal" (click)="onAddMoney()">{{data.buttonName[1]}}</button>
    </article>
</section>
